import React, { useMemo } from "react";

// components

import TablePageVisits from "../../components/Table/TablePageVisits";
import TableSocialTraffic from "../../components/Table/TableSocialTraffic";
import CardChart from "../../components/Cards/CardChart";
import dummyPages from "../../data/pageVisit.json";
import Table from "../../layouts/Table";
import { useFetch } from "../../hooks/useFetch";

export default function Dashboard() {
  const [result] = useFetch(
    useMemo(() => {
      return {
        startDate: "7daysAgo",
        endData: "today",
        metrics: [
          "ga:pageviews",
          "ga:sessions",
          "ga:pageviewsPerSession",
          "ga:bounces",
        ],
      };
    }, [])
  );
  const [pageViews] = useFetch(
    useMemo(() => {
      return {
        startDate: "7daysAgo",
        endData: "today",
        dimensions: ["ga:pagePath"],
        metrics: ["ga:pageviews"],
        maxResults: "5",
      };
    }, [])
  );
  const [device] = useFetch(
    useMemo(() => {
      return {
        startDate: "7daysAgo",
        endData: "today",
        dimensions: ["ga:deviceCategory"],
        metrics: ["ga:users"],
      };
    }, [])
  );

  const [browser] = useFetch(
    useMemo(() => {
      return {
        startDate: "7daysAgo",
        endData: "today",
        dimensions: ["ga:browser"],
        metrics: ["ga:users"],
      };
    }, [])
  );

  const [region] = useFetch(
    useMemo(() => {
      return {
        startDate: "7daysAgo",
        endData: "today",
        dimensions: ["ga:region"],
        metrics: ["ga:users"],
      };
    }, [])
  );

  return (
    <div className="grid gap-y-6">
      <div className="grid grid-cols-10 gap-x-6">
        <div className="w-full h-full col-span-7">
          <CardChart type="line" data={result} title="General insight" />
        </div>
        <div className="w-full col-span-3">
          <CardChart type="doughnut" data={pageViews} title="Page visit" />
        </div>
      </div>
      <div className="grid grid-cols-12 gap-x-6">
        <CardChart
          height={"1000px"}
          type="doughnut"
          className="col-span-2"
          title="Browser"
          data={browser}
        />
        <CardChart
          type="doughnut"
          className="col-span-2"
          title="device"
          data={device}
        />

        <Table
          icon="fab fa-twitter"
          iconColor="text-sky-400"
          title="Social Reference"
          className="w-full col-span-8"
        >
          {" "}
          <TableSocialTraffic />
        </Table>
      </div>

      <div className="grid grid-cols-12 gap-x-6">
        <Table
          icon="fas fa-bookmark"
          iconColor="text-purple-500"
          title="Page Visits"
          className="col-span-10"
        >
          {" "}
          <TablePageVisits data={dummyPages} />
        </Table>
        <CardChart
          type="pie"
          className="col-span-2"
          title="location"
          data={region}
        />
      </div>
    </div>
  );
}
